/**
 * The web token manager's record of the session refresh in flight (PRTL-1519): a request
 * rejected with the old token waits for it, then retries with the new one. Shared so the
 * deadlock test (server/src/utils/trpcFetch.test.ts) runs the same code the app does.
 */
export class RefreshTracker {
    #refreshing: Promise<unknown> | null = null;

    /** Marks `refresh` as the refresh in flight until it settles. */
    track = <T>(refresh: Promise<T>): Promise<T> => {
        this.#refreshing = refresh;
        const clear = () => {
            if (this.#refreshing === refresh) this.#refreshing = null;
        };
        refresh.then(clear, clear);
        return refresh;
    };

    /** Resolves once no refresh is in flight (whatever its outcome). */
    wait = async (): Promise<void> => {
        while (this.#refreshing) {
            await this.#refreshing.catch(() => undefined);
        }
    };
}
